import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OurAccordion from '../../../../../../_elements/OurAccordion';
import LabelItem from '../../../../EVVContainer/Visit/Label/LabelItem';
import CreateLabel from '../../../../EVVContainer/Visit/Label/CreateLabel';

function VisitLabels() {
	const visits = useSelector((state) => state?.user?.user?.labelInfo?.labels?.visits);
	const [visitsLabel, setVisitsLabel] = useState({});

	useEffect(() => {
		setVisitsLabel(visits);
	}, [visits]);

	return (
		<OurAccordion title="Visit Labels">
			<div className="d-flex justify-content-end">
				<CreateLabel />
			</div>
			<hr />
			<div>
				{Object.keys(visitsLabel).map((key) => (
					<LabelItem key={key} title={key} color={visitsLabel[key]} />
				))}
			</div>
		</OurAccordion>
	);
}

export default VisitLabels;
